import React from "react";
import { HeartIcon } from "lucide-react";
import { PurchaseButton } from "./PurchaseButton";
import { Daisy } from "./decor/Daisy";
import { LeafSprig } from "./decor/LeafSprig";
export function ClosingSection() {
  return <section className="relative overflow-hidden bg-rosy-light" data-id="element-32" data-mp="12tmyo1yrmfjt">
      <LeafSprig className="pointer-events-none absolute -left-3 bottom-8 w-20 md:w-24" data-id="element-33" data-mp="xt8zzaj20hyg" />
      <LeafSprig className="pointer-events-none absolute -right-3 top-8 w-20 rotate-180 md:w-24" data-id="element-34" data-mp="1cqrpwg7gx17h" />
      <Daisy className="pointer-events-none absolute left-[12%] top-10 hidden w-10 md:block" data-id="element-35" data-mp="17s6km2dczrc6" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center md:py-28" data-id="element-36" data-mp="1lj3dlub76ajr">
        <HeartIcon className="mx-auto h-10 w-10 fill-rosy text-rosy" aria-hidden="true" data-id="element-37" data-mp="1ll6044d55ljq" />
        <h2 className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-royal md:text-5xl md:leading-[1.08]" data-id="element-38" data-mp="1hjuial0ie4m3">
          La foi se transmet aussi dans les{" "}
          <span className="text-tangerine" data-id="element-39" data-mp="1qjr50h3c8tei">petits moments partagés.</span>
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-cocoa md:text-xl" data-id="element-40" data-mp="22ddvnvf5bk1q">
          Une histoire avant de dormir. Une question posée avec tendresse. Une activité
          réalisée ensemble. Parfois, ce sont ces petits instants qui laissent les plus beaux
          souvenirs dans le cœur d’un enfant.
        </p>
        <p className="mt-8 font-display text-xl font-bold leading-snug text-royal-deep md:text-2xl" data-id="element-41" data-mp="2gdop967ubcql">
          Commencez à créer ces moments avec votre Méga Pack de Paraboles Chrétiennes.
        </p>
        <div className="mx-auto mt-10 max-w-md" data-id="element-42" data-mp="2q8qc1ven82q0">
          <PurchaseButton label="Je découvre le Méga Pack" data-id="element-43" data-mp="2v19ryz0sz9xz" />
        </div>
      </div>
    </section>;
}